/*
  Limita gli swatch colore nelle card prodotto a MAX pallini e aggiunge un badge "+N".
  Rispetto alla versione precedente (solo DOMContentLoaded) gira anche sulle card
  inserite dopo il primo caricamento: paginazione, "carica altri", filtri, ordinamento,
  sezioni rivelate allo scroll, navigazione instant. Ogni fieldset viene processato una sola volta.
*/
(() => {
  const MAX = 4;
  const SELECTOR = 'product-card fieldset.h-stack';

  const process = (fieldset) => {
    if (fieldset.dataset.swatchLimited) return;
    const swatches = Array.from(fieldset.querySelectorAll('label.color-swatch'));
    if (swatches.length <= MAX) { fieldset.dataset.swatchLimited = 'no-overflow'; return; }
    fieldset.dataset.swatchLimited = 'limited';

    const hidden = [];
    swatches.forEach((label, i) => {
      if (i < MAX) return;
      const input = document.getElementById(label.getAttribute('for'));
      label.style.display = 'none';
      if (input) input.style.display = 'none';
      hidden.push({ label, input });
    });

    const badge = document.createElement('span');
    badge.className = 'swatch-overflow-badge';
    badge.textContent = `+${swatches.length - MAX}`;
    badge.style.cursor = 'pointer';
    badge.setAttribute('role', 'button');
    badge.setAttribute('aria-label', `Mostra altri ${swatches.length - MAX} colori`);
    badge.addEventListener('click', (e) => {
      e.preventDefault();
      hidden.forEach(({ label, input }) => { label.style.display = ''; if (input) input.style.display = ''; });
      badge.remove();
      fieldset.dataset.swatchLimited = 'expanded';
    });
    fieldset.appendChild(badge);
  };

  const scan = (root = document) => root.querySelectorAll(SELECTOR).forEach(process);

  let scheduled = false;
  const scheduleScan = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  };

  const start = () => {
    scan();
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length) { scheduleScan(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  PDP — selettore colore custom (blocco "Custom variant picker" in templates/product.json):
  gli swatch e le voci del drawer con data-available="false" ignoravano il click, quindi
  scegliendo un colore esaurito l'immagine non cambiava (feedback cliente, punto 4).
  Qui intercettiamo il click sugli elementi non disponibili e selezioniamo comunque il radio
  nativo Prestige: la galleria mostra la variante, il tema la marca come "Esaurito".
*/
(() => {
  const selectOptionValue = (id) => {
    const radio = document.querySelector('input[type="radio"][value="' + CSS.escape(id) + '"]');
    if (!radio) return false;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };
  document.addEventListener('click', (e) => {
    const li = e.target.closest('.mrnt-swatch--unavailable, .mrnt-drawer-item--unavailable');
    if (!li || !li.dataset.optionValueId) return;
    if (!selectOptionValue(li.dataset.optionValueId)) return;
    const current = document.querySelector('.mrnt-color-picker .mrnt-current');
    if (current && li.dataset.colorName) current.textContent = li.dataset.colorName;
    if (li.classList.contains('mrnt-drawer-item--unavailable')) {
      document.querySelector('body > .mrnt-drawer.open [data-mrnt-close]')?.click();
    }
  }, true);
})();
